import React from 'react';
import styled from 'styled-components';

import { IProduct } from 'models';

interface IProps {
  products: IProduct[];
  productSelected: (product: IProduct) => void;
}

interface IState {
  selectedProduct: IProduct | null;
}

const TableContainer = styled.div`
  overflow-x: auto;
  display: flex;
  flex-direction: row;
  overflow-y: hidden;
  flex-wrap: wrap;
`;

const Table = styled.table`
  border-collapse: collapse;
  table-layout: fixed;
  overflow-x: auto;
  overflow-y: hidden;
  z-index: 1;
  height: 95%;
  margin: auto;
`;

const Th = styled.th<{ selected: boolean }>`
  border:1px solid #DDD;
  padding:10px;
  empty-cells:show;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: calc(0.4em + 0.5vw);

  transition: background-color 0.2s ease, color 0.2s ease;
  background-color: ${(props) => props.selected ? '#FF7203' : 'white'};
  color: ${(props) => props.selected ? 'white' : 'black'};
  outline: ${(props) => props.selected ? 'none' : ''};

  :hover {
    cursor: pointer;
    background-color: aliceblue;
  }
`;

const Td = styled.td<{ selected: boolean }>`
  height: 53px;
  border: 1px solid #DDD;
  padding: 10px;
  empty-cells: show;
  text-align: left;
  display: table-cell;
  font-size: calc(0.4em + 0.5vw);
  position: relative;
  transition: background-color 0.2s ease, color 0.2s ease;

  background-color: ${(props) => props.selected ? '#FF7203' : 'white'};
  color: ${(props) => props.selected ? 'white' : 'black'};
  outline: ${(props) => props.selected ? 'none' : ''};

  :hover {
    cursor: pointer;
  }

  :hover::after {
    border: 1px solid #FFA965AA;
    content: '';
    height: 10000px;
    left: 0;
    position: absolute;
    top: -5000px;
    width: 100%;
    z-index: 1;
  }
`;

const KeyTd = styled.td`
  height: 53px;
  border: 1px solid #DDD;
  padding: 10px;
  empty-cells: show;
  text-align: left;
  font-weight: bold;
  display: table-cell;
  column-span: 2;
  font-size: calc(0.4em + 0.5vw);
`;

class ResultTable extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedProduct: null
    };
  }

  exists = (existing: Array<{ key: string, value: string, unit?: string }>, key: string) => {
    return existing.find((x) => x.key === key) != null;
  }

  getFormattedMetadata = (metadata: Array<{ key: string, value: string, unit?: string }>) => {
    const formattedData = new Array<{ key: string, value: string, unit?: string }>();
    const excludedKeys = ['engine-id'];

    metadata.forEach((data) => {
      if (!excludedKeys.includes(data.key)) {
        if (!this.exists(formattedData, data.key)) {
          formattedData.push({ ...data });
        } else {
          if (!formattedData[formattedData.findIndex((x) => x.key === data.key)].value.includes(data.value)) {
            formattedData[formattedData.findIndex((x) => x.key === data.key)].value += ` / ${data.value}`;
          }
        }
      }
    });

    return formattedData;
  }

  render() {
    const { products, productSelected } = this.props;
    const { selectedProduct } = this.state;

    const handleRowClicked = (selectedProduct: IProduct) => {
      this.setState({
        selectedProduct
      });

      productSelected(selectedProduct);
    };

    const ResolveValueAndUnit = (product: IProduct, data: { key: string, value: string, unit?: string }) => {
      let value = '';
      let unit = '';

      const x = this.getFormattedMetadata(product.metadata).filter((item) => item.key === data.key)[0];
      if (x === undefined) value = '';
      else value = x.value;

      const item = product.metadata.filter(function (item) { return item.key === data.key; })[0];
      if (item !== undefined && item.unit !== undefined) unit = item.unit;

      return `${value} ${unit}`;
    };

    return (
      <TableContainer>
        <Table>
          <thead>
            <tr>
              <th />
              {products.map((product) => {
                return (
                  <Th
                    key={JSON.stringify(product)}
                    selected={product === selectedProduct}
                    onClick={() => handleRowClicked(product)}
                  >
                    {product.name}
                  </Th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {this.getFormattedMetadata(products[0].metadata).map((data) => {
              return (
                <tr key={JSON.stringify(products[0])}>
                  <KeyTd key={data.key}>
                    {data.key}
                  </KeyTd>
                  {products.map((product) => {
                    return (
                      <Td
                        key={JSON.stringify(product)}
                        selected={product === selectedProduct}
                        onClick={() => handleRowClicked(product)}
                      >
                        {
                          `${ResolveValueAndUnit(product, data)}`
                        }
                      </Td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </TableContainer>
    );
  }
}

export default ResultTable;
